import React from 'react';

class SelectEvent extends React.Component {

    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillUnmount() {
        const originalSelectedEvent = this.props.participants.events.find(e => e.selected);
        this.props.events.onSelectEventForParticipants(originalSelectedEvent.id);
    }

    handleChange(e) {
        e.preventDefault();
        this.props.events.onSelectEventForParticipants(e.target.value);
        this.props.handleChange ? this.props.handleChange(e.target.value) : null;
    };

    render() {
        const participants = this.props.participants;
        const events = participants.events;

        return (
            <select value={participants.selectedEvent ? participants.selectedEvent.id : ""}
                    onChange={this.handleChange}
                    className="form-control">
                <option key="null" value="">Selecione um evento</option>
                {events.map(function (event) {
                    return <option key={event.id} value={event.id}>{event.name}</option>
                })}
            </select>
        );
    }
}

export default SelectEvent;



// WEBPACK FOOTER //
// src/views/controls/SelectEvent.jsx